import { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

const CollapsiblePanel = ({ title, children, className, initialOpen }) => {
    const [isOpen, setIsOpen] = useState(initialOpen);

    return (
        <div className={className}>
            <div
                className="flex items-center panel-label space-x-3 cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="">{title || 'Advanced'}</div>

                <div className="w-4 h-4">
                    {isOpen && <ChevronDownIcon />}
                    {!isOpen && <ChevronUpIcon />}
                </div>
            </div>
            {isOpen && <div className="panel">{children}</div>}
        </div>
    );
};

export default CollapsiblePanel;
